import { Params } from '@angular/router';
import { Product } from '../../shared/classes/product';
import { PRODUCT_DETAIL_PLACEHOLDER_SLUG } from '../constants/product-detail.constants';

const DEFAULT_ID_PROVEEDOR = 1;

/** SKU para ruta `/shop/product/:sku`. */
export function resolveProductDetailSku(product: Product | null | undefined): string {
  const sku = product?.sku?.trim();
  if (sku) {
    return sku;
  }

  const fromTags = product?.tags?.[0];
  if (fromTags != null && `${fromTags}`.trim()) {
    return `${fromTags}`.trim();
  }

  const slug = (product?.title ?? '').replace(/ /g, '-').trim();
  return slug || PRODUCT_DETAIL_PLACEHOLDER_SLUG;
}

/** idProveedor para consultar-sku (home shop / catálogo). */
export function resolveProductDetailIdProveedor(product: Product | null | undefined): number {
  const id = Number(product?.idProveedor);
  if (Number.isFinite(id) && id >= 1) {
    return Math.trunc(id);
  }
  return DEFAULT_ID_PROVEEDOR;
}

/** Segmentos de routerLink: `['/shop/product', sku]`. */
export function productDetailRouterLink(product: Product | null | undefined): string[] {
  return ['/shop/product', resolveProductDetailSku(product)];
}

/** Query params para PDP (`idProveedor`). */
export function productDetailQueryParams(product: Product | null | undefined): Params {
  return { idProveedor: resolveProductDetailIdProveedor(product) };
}

/** @deprecated Usar resolveProductDetailSku */
export function resolveProductDetailSlug(product: Product | null | undefined): string {
  return resolveProductDetailSku(product);
}
